import Splide from '@splidejs/splide';

interface TeaserSliderOptions {
    defaults: {
        name: string;
        selectors: {
            slideContainer: string;
            item: string;
        };
    };
}

export function init() {
    const elements = document.querySelectorAll<HTMLElement>('.teaser-slider');
    const defaultOptions: TeaserSliderOptions = {
        defaults: {
            name: 'Teaser Slider',
            selectors: {
                slideContainer: '.splide',
                item: '.teaser-slider__item',
            },
        },
    };

    TeaserSlider(elements, defaultOptions);
}

export default function TeaserSlider(elements: NodeListOf<HTMLElement>, options: TeaserSliderOptions) {
    process.env.NODE_ENV === 'development' &&
        console.info(`Init: ${options.defaults.name}`);

    for (let i = 0; i < elements.length; i++) {
        initSlider(elements[i], options);
    }
}

function initSlider(element: HTMLElement, options: TeaserSliderOptions) {
    const splide = element.querySelector(
        options.defaults.selectors.slideContainer,
    ) as HTMLElement;

    if (splide) {
        new Splide(splide, {
            arrows: true,
            pagination: false,
            perPage: 4,
            breakpoints: {
                640: {
                    perPage: 1,
                },
                768: {
                    perPage: 2,
                },
                992: {
                    perPage: 2,
                },
                1199: {
                    perPage: 3,
                }
            },
            perMove: 1,
            gap: 24,
            autoWidth: true,
            fixedWidth: '278px',
            arrowPath: 'm26.154 20.468 -4.164 4.18a0.66 0.66 0 0 1 -0.468 0.201 0.661 0.661 0 0 1 -0.468 -0.2 0.666 0.666 0 0 1 0 -0.954l3.027 -3.026H14.315a0.671 0.671 0 0 1 -0.669 -0.669c0 -0.368 0.301 -0.669 0.669 -0.669h9.765l-3.043 -3.043a0.666 0.666 0 0 1 0 -0.954 0.666 0.666 0 0 1 0.953 0L26.154 19.515c0.268 0.267 0.268 0.702 0 0.953Z',
        }).mount();
    }
}
